import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Mail } from 'lucide-react';
import Modal from './PrivacyPolicyModal';
import PrivacyPolicy from './PrivacyPolicy';
import logo from '../assets/coplaid-logo-transparent.png';
import './Footer.css';

export default function Footer() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <footer className="cp-footer">
      <div className="cp-container">
        <div className="cp-footer-grid">
          <div className="cp-footer-brand">
            <img src={logo} alt="CoPlaid" />
            <p>
              One platform for the conversation between agents, devices and the people who
              depend on them.
            </p>
          </div>

          <div>
            <h4>Platform</h4>
            <ul>
              <li><a href="/product" onClick={go('/product')}>Product</a></li>
              <li><a href="/partners" onClick={go('/partners')}>Partners</a></li>
              <li><a href="/ship" onClick={go('/ship')}>Ship</a></li>
            </ul>
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="/contact" onClick={go('/contact')}>Contact</a></li>
            </ul>
          </div>

          <div>
            <h4>Legal</h4>
            <ul>
              <li>
                <a
                  href="#privacy"
                  onClick={(e) => { e.preventDefault(); setOpen(true); }}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
                >
                  <Shield size={14} /> Privacy Policy
                </a>
              </li>
              <li>
                <a href="mailto:admin@coplaid.ai" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  <Mail size={14} /> admin@coplaid.ai
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="cp-footer-bottom">
          <span>© CoPlaid {new Date().getFullYear()}. All rights reserved.</span>
          <span style={{ color: 'rgba(255,255,255,0.5)' }}>Built in California.</span>
        </div>
      </div>

      <Modal open={open} onClose={() => setOpen(false)}>
        <PrivacyPolicy />
      </Modal>
    </footer>
  );
}
